import React from "react"
import { Tab, Tabs } from "react-bootstrap"
import { adaptNFe, getNFeConfig, importNFeFromInvoicy } from "../../../../../api/nfe"

import Modal from "../../../../../_components/Modal"
import Button from "../../../../../_components/Button"
import LoadingInput from "../../../../../_components/LoadingInput"
import { showSnackBar } from "../../../../../utils"

const DEFAULT_RANGE = { start_number: 1, end_number: 11, series: 1 }
const DEFAULT_IMPORT_NFE_DATA = { number: "", series: "" }

const START_NUMBER_ID = "a2915682-5890-4571-bf46-59113dcf70db-adjment-note-start-number"
const END_NUMBER_ID = "b9788701-0c60-4910-ac01-337b76494cc5-adjment-note-end-number"
const SERIES_ID = "4b9e49fc-a9c5-4c46-b5c6-3f05fe184d32-adjment-note-series"

function getCachedNFeConfig() {
    try {
        const currentBranch = window.localStorage.getItem("easygestorweb_current_branch")
        if (!currentBranch) {
            return null
        }

        const branch = JSON.parse(currentBranch)
        return branch.fiscal_config || null
    } catch (error) {
        return null
    }
}

function mapConfigToImportData(config) {
    if (!config) {
        return DEFAULT_IMPORT_NFE_DATA
    }

    return {
        number: config.nfe_number === undefined || config.nfe_number === null
            ? ""
            : config.nfe_number,
        series: config.nfe_serie === undefined || config.nfe_serie === null
            ? ""
            : config.nfe_serie,
    }
}

function isIntegerAtLeast(value, minimum) {
    const normalizedValue = String(value).trim()
    return /^\d+$/.test(normalizedValue) && Number(normalizedValue) >= minimum
}

function getImportErrorMessage(error) {
    if (typeof error === "string") {
        return error
    }

    if (error && error.error) {
        return error.error
    }

    if (error && error.detail) {
        return error.detail
    }

    return "Não foi possível importar a NF-e. Verifique o número e a série e tente novamente."
}

export default () => {
    const [show, setShow] = React.useState(false)
    const [showAjustar, setShowAjustar] = React.useState(false)
    const [finish, setFinish] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [range, setRange] = React.useState(DEFAULT_RANGE)
    const [activeTab, setActiveTab] = React.useState("adjustment")
    const [importReady, setImportReady] = React.useState(false)
    const [importNFeData, setImportNFeData] = React.useState(DEFAULT_IMPORT_NFE_DATA)
    const [importConfigLoading, setImportConfigLoading] = React.useState(false)
    const [importConfigError, setImportConfigError] = React.useState("")
    const [importLoading, setImportLoading] = React.useState(false)

    const hasValidImportData = isIntegerAtLeast(importNFeData.number, 1)
        && isIntegerAtLeast(importNFeData.series, 0)

    function closeModal() {
        if (loading || importLoading) {
            showSnackBar("Requisição em andamento ...")
            return
        }
        setShow(false)
        setShowAjustar(false)
        setRange(DEFAULT_RANGE)
        setActiveTab("adjustment")
        setImportReady(false)
        setImportNFeData(DEFAULT_IMPORT_NFE_DATA)
        setImportConfigLoading(false)
        setImportConfigError("")
        setImportLoading(false)
    }

    function onChange(e) {
        let { name: key, value } = e.target
        if (parseInt(value, 10) < 1) {
            value = 1
        }
        const newRange = { ...range }
        newRange[key] = value
        setRange(newRange)
        setTimeout(() => {
            verifyRangeLimit()
        }, 100)
    }

    function verifyRangeLimit() {

    }

    function handleInitAdjument() {
        setLoading(true)
        adaptNFe(range)
            .then(resp => {
                setLoading(false)
                setShow(false)
                setFinish(true)
            })
            .catch(resp => {
                setLoading(false)
            })
    }

    function setInputFocus() {
        if (!show || activeTab !== "adjustment") {
            return
        }
        setTimeout(() => {
            try { document.getElementById(START_NUMBER_ID).focus() } catch (error) { }
        }, 200)
    }

    function handleImportDataChange(e) {
        const { name, value } = e.target
        setImportNFeData({ ...importNFeData, [name]: value })
        setImportReady(false)
    }

    function prepareNFeImport() {
        if (!hasValidImportData || importLoading) {
            return
        }

        setImportLoading(true)
        setImportReady(false)

        importNFeFromInvoicy({
            number: Number(importNFeData.number),
            series: Number(importNFeData.series),
        })
            .then(() => {
                setImportReady(true)
                showSnackBar("NF-e importada com sucesso!", "info")
            })
            .catch(error => {
                showSnackBar(getImportErrorMessage(error), "danger", 10000)
            })
            .then(() => {
                setImportLoading(false)
            })
    }

    React.useEffect(setInputFocus, [show, activeTab])

    React.useEffect(() => {
        if (!show) {
            return undefined
        }

        let mounted = true
        const cachedConfig = getCachedNFeConfig()

        if (cachedConfig) {
            setImportNFeData(mapConfigToImportData(cachedConfig))
        }

        setImportConfigError("")
        setImportConfigLoading(true)

        getNFeConfig()
            .then(config => {
                if (mounted) {
                    setImportNFeData(mapConfigToImportData(config))
                }
            })
            .catch(() => {
                if (mounted && !cachedConfig) {
                    setImportConfigError(
                        "Não foi possível carregar as configurações. Informe o número e a série manualmente."
                    )
                }
            })
            .then(() => {
                if (mounted) {
                    setImportConfigLoading(false)
                }
            })

        return () => {
            mounted = false
        }
    }, [show])


    return <div>
        <p>
            Algo está errado?
        </p>
        <Button
            onClick={() => setShow(true)}>
            <strong className="text-white">
                Consultar nota(s)<i className="fas fa-wrench ml-2" />
            </strong>
        </Button>
        <Modal
            title="Documentos NF-e"
            show={show}
            onHide={closeModal} >
            <Tabs
                activeKey={activeTab}
                id="nfe-document-actions-tabs"
                onSelect={setActiveTab}>
                <Tab eventKey="adjustment" title="Corrigir NF-e">
                    <div className="row pt-4">
                        <div className="col-12">
                            <p>
                                Consulta de documentos:
                            </p>
                            <ul>
                                <li>
                                    O sistema realizará uma consulta na SEFAZ e irá corrigir os documentos (NF-e)
                                </li>
                                <li>
                                    Intervalo máximo de 30 documentos (NF-e) por consulta
                                </li>
                            </ul>
                        </div>
                        <div className="col-md-4 col-12">
                            <p className="lead">
                                Número inicial
                            </p>
                            <LoadingInput
                                name="start_number"
                                type="number"
                                id={START_NUMBER_ID}
                                loading={loading}
                                value={range.start_number}
                                onChange={onChange}
                            />
                        </div>
                        <div className="col-md-4 col-12">
                            <p className="lead">
                                Número final
                            </p>
                            <LoadingInput
                                name="end_number"
                                type="number"
                                value={range.end_number}
                                loading={loading}
                                id={END_NUMBER_ID}
                                onChange={onChange}
                            />
                        </div>
                        <div className="col-md-4 col-12">
                            <p className="lead">
                                Série
                            </p>
                            <LoadingInput
                                name="series"
                                type="number"
                                loading={loading}
                                value={range.series}
                                id={SERIES_ID}
                                onChange={onChange}
                            />
                        </div>
                        <div className={`${showAjustar ? "col-md-4 col-12" : "d-none"}`}>
                            <p className="lead">
                                Recuperar
                            </p>
                            <LoadingInput
                                name="recuperar"
                                as="select"
                                loading={loading}
                                value={range.recuperar || "não"}
                                id="adjustment-note-recover"
                                onChange={onChange}>
                                <option value="sim">SIM</option>
                                <option value="não">NÃO</option>
                            </LoadingInput>
                        </div>
                        <div className="col-12">
                            <Button as="text" onClick={() => setShowAjustar(!showAjustar)}>
                                avançado
                            </Button>
                        </div>
                        <div className="col-12">
                            <div className="alert alert-primary">
                                <p className="lead p-0 m-0">
                                    Intervalo: <strong>
                                        {range.end_number - range.start_number}
                                    </strong>
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4 mt-3 mx-auto d-flex justify-content-center">
                            <Button
                                disabled={loading}
                                onClick={handleInitAdjument}>
                                <strong>
                                    {
                                        loading
                                            ? "Correção em andamento"
                                            : "Iniciar Correção dos documentos"
                                    }
                                </strong>
                            </Button>
                        </div>
                    </div>
                </Tab>
                <Tab eventKey="import" title="Importar NF-e">
                    <div className="row pt-4">
                        <div className="col-12">
                            <p className="mb-2">Importar NF-e:</p>
                            <small className="text-muted d-block mb-3">
                                Informe o número e a série da NF-e. Os valores são carregados das configurações,
                                mas podem ser alterados para esta importação.
                            </small>
                        </div>
                        <div className="col-md-6 col-12">
                            <LoadingInput
                                label="Número da NF-e"
                                disabled={importLoading}
                                loading={importConfigLoading}
                                min="1"
                                name="number"
                                onChange={handleImportDataChange}
                                step="1"
                                type="number"
                                value={importNFeData.number}
                            />
                        </div>
                        <div className="col-md-6 col-12">
                            <LoadingInput
                                label="Série da NF-e"
                                disabled={importLoading}
                                loading={importConfigLoading}
                                min="0"
                                name="series"
                                onChange={handleImportDataChange}
                                step="1"
                                type="number"
                                value={importNFeData.series}
                            />
                        </div>
                        {importConfigError && (
                            <div className="col-12">
                                <div className="alert alert-warning py-2" role="alert">
                                    {importConfigError}
                                </div>
                            </div>
                        )}
                        {!importConfigLoading && !hasValidImportData && (
                            <div className="col-12">
                                <small className="text-danger d-block mb-3">
                                    Informe um número maior que zero e uma série igual ou maior que zero.
                                </small>
                            </div>
                        )}
                        <div className="col-12 d-flex justify-content-center py-2 mt-2">
                            <Button
                                disabled={!hasValidImportData || importConfigLoading || importLoading}
                                loading={importLoading}
                                onClick={prepareNFeImport}>
                                <strong>{importLoading ? "Importando NF-e" : "Importar NF-e"}</strong>
                            </Button>
                        </div>
                        {importReady && (
                            <div className="col-12 mt-3">
                                <div className="alert alert-primary mb-0" role="status">
                                    <p className="mb-0">
                                        NF-e nº <strong>{importNFeData.number}</strong>, série{" "}
                                        <strong>{importNFeData.series}</strong>, importada com sucesso.
                                    </p>
                                </div>
                            </div>
                        )}
                    </div>
                </Tab>
            </Tabs>
        </Modal>
        <Modal title="Correção finalizada." show={finish}>
            <div>
                <h2 className="text-center">
                    Correção aplicada aos documentos.
                </h2>
                <div className="d-flex justify-content-center">
                    <Button onClick={() => { window.location.reload() }}>
                        Finalizar
                    </Button>
                </div>
            </div>
        </Modal>
    </div>
}



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/List/AdjustmentNotes/index.jsx